import Login from '@/views/auth/Login.vue'

export default [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      requiresAuth: false,
      guest: true,
      fail: '/404.html'
    }
  }
]
